import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

export interface NotificationProps {
  info?: boolean;
  alert?: boolean;
  success?: boolean;
  warning?: boolean;
  small?: boolean;
  large?: boolean;
}
const backgroundColor = css<NotificationProps>`
  background-color: ${({ info, alert, theme, success, warning }) => {
    if (info) {
      return theme.color.brand01;
    } else if (success) {
      return theme.color.good;
    } else if (alert) {
      return theme.color.bad;
    } else if (warning) {
      return theme.color.neutral;
    } else {
      return 'white';
    }
  }};
`;

const fontSize = css`
  font-size: ${({ theme }) => theme.x1space + 0.4}rem;
  ${media.mdUp`
		font-size: ${({ theme, small }) =>
      !small ? theme.x2space : theme.x1space + 0.4}rem;
	`};
`;

const color = css<NotificationProps>`
  color: ${({ warning }) => {
    if (warning) {
      return 'black';
    } else {
      return 'white';
    }
  }};
`;

const padding = css<NotificationProps>`
  padding: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdUp`
		padding: ${({ theme, small, large }) => {
      if (small) {
        return `${theme.x1spacePx}px`;
      } else if (large) {
        return `${(theme.x2space + 0.4) * 10}px ${theme.x2spacePx}px`;
      } else {
        return `${(theme.x1space + 0.4) * 10}px`;
      }
    }};
	`};
`;

const Notification = styled('div')<NotificationProps>`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${color}
  ${padding}
	${fontSize}
	${backgroundColor}
`;

export default Notification;
